import React from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import BusComponent from '../../../components/BusComponent';
import SatelliteLegend from "./SatelliteLegend";
import VisualizationEditor from "./VisualizationEditor";
import BaseMap from "../../../enums/BaseMapTypes";

class BasemapEditor extends BusComponent {
    constructor(props, context) {
        super(props, context);

        this.state = {
            activeBaseMap: BaseMap.STANDARD,
            metadata: undefined,
        };
    }

    componentWillMount() {
        this.bindGluBusEvents({
            MAP_NEW_DATA_THEME_APPLIED: this.loadMetadata,
        });
    }


    onMetadataLoaded = (metadata, source) => {
        if (source !== this) return;
        this.setState({ metadata });
    };

    loadMetadata() {
        const { mapInstance } = this.props;

        this.bus.once('CURRENT_METADATA', this.onMetadataLoaded);
        this.emit('CURRENT_METADATA_REQUEST', { source: this });

        this.emit('VARIABLE_SELECTION_METADATA_INFO_REQUEST', {
            source: this,
            dataDictionaryInfo: true,
            mapInstanceId: mapInstance.id,
            variableSelectionItems: mapInstance.dataTheme.variableSelection.items,
        });

        // check if it is possible to allow change over time
        this.emit('CHECK_CHANGE_OVER_TIME_AVAILABILITY', {
            source: this,
            mapInstanceId: mapInstance.id,
        });
    }

    componentDidMount() {
        const { mapInstance } = this.props;

        this.setState({
            activeBaseMap: mapInstance.activeBaseMap
        });
        this.loadMetadata();
    }

    componentWillUnmount() {
        this.unbindGluBusEvents();
    }

    onCloseSatelliteDetails = (selectedBaseMap) => {
        this.setState({
            activeBaseMap: selectedBaseMap
        });
    }

    render() {
        const { mapInstance, onShowDataBrowser } = this.props;
        const { activeBaseMap } = this.state;

        const showVisualizationEditor = activeBaseMap === BaseMap.SATELLITE || activeBaseMap === BaseMap.STANDARD;

        return (
            <div className="basemap-editor">
                <SatelliteLegend
                    mapInstance={mapInstance}
                    onClose={this.onCloseSatelliteDetails}
                />
                {showVisualizationEditor && (
                    <VisualizationEditor
                        onShowDataBrowser={onShowDataBrowser}
                        mapInstance={mapInstance}
                    />
                )}
            </div>
        );
    }
}

BasemapEditor.propTypes = {
    mapInstance: PropTypes.object.isRequired,
    onShowDataBrowser: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
};

export default injectIntl(BasemapEditor);
